/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import { compose } from 'redux';
import PropTypes, {
    bool, string, shape, object,
} from 'prop-types';
import * as Joi from 'joi-browser';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import Form from '../../../common/Form';
import { uuidv4 } from '../../../utils/uuid';
import { cipher } from '../../../utils/crypto';
import configENV from '../../../config';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import DesktopTrackOrderByEmailStyle from '../../../style/DesktopTrackOrderByEmailStyle';
import withValidation from '../../../../Checkout/containers/CheckoutFloral/Partials/TextFieldWrapper/ValidationHOC';
import TextFieldWrapper from '../../../../Checkout/containers/CheckoutFloral/Partials/TextFieldWrapper/TextFieldWrapper';
import { getDataDictionary, getSSRDeviceType } from '../../../../../../state/ducks/App/App-Selectors';

import {
    getOrderStatus,
    getOrderConfirmationId,
} from '../../../../../../state/ducks/Checkout/Checkout-Selectors';

const { PERSIST_KEY } = configENV;

class DesktopOrderByEmail extends Form {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                orderNumber: '',
                email: '',
            },
        };
    }

    schema = {
        orderNumber: Joi.string()
            .trim()
            .regex(/^(([W|w]{1}\d{13,14})|(\d{9}))$/i, 'order number format') // this regex will recieve order number with W or without min length 8 max is 30
            .min(8)
            .max(30)
            .required()
            .label('Order Number'),
        email: Joi.string()
            .trim()
            .min(5)
            .max(50)
            .required()
            .label('Email ID'),
    };

    doSubmit = () => {
        const { featureFlags, ssrDeviceType, handleSubmitOrderByEmail } = this.props;
        const data = { ...this.state.data };

        const uuid = uuidv4();
        const cipherKey = uuid.slice(0, 8);
        data.uuid = uuid;
        data.cryptedOrderNumber = cipher(cipherKey)(data.orderNumber).replace(
            /^(.{8})(.{4})(.{4})(.{4})(.+)$/,
            '$1-$2-$3-$4-$5',
        );
        data.cryptedEmail = cipher(cipherKey)(data.email);

        const url = `/order-information/${data.uuid}/${data.cryptedOrderNumber}/${data.cryptedEmail}`;

        data.featureFlags = featureFlags;
        data.ssrDeviceType = ssrDeviceType;
        data.callBack = { url };
        handleSubmitOrderByEmail(data);
    };

    render() {
        /* eslint-disable max-len */
        const {
            classes,
            formFieldState,
            dataDictionary,
            isReadyState,
            error,
        } = this.props;

        const handleFieldChange = (event) => {
            this.setState((prevState) => ({
                data: {
                    ...prevState.data,
                    [event?.target?.name]: event?.target?.value,
                },
            }));
        };

        const handleFieldBlur = (key, response) => {
            const { handleOnBlur } = this.props;
            handleOnBlur(key, response, this.state.data);
        };

        return (
            <div className={classes.DesktopTrackOrderByEmailStyle}>
                <div className="mb-3 mb-md-4 row">
                    <div className="col-md-12">
                        <h1 className="heading">
                            Tracking your Order is easier than ever!
                        </h1>
                    </div>
                </div>
                <div className="mt-4 row">
                    <div className="col-md-12">
                        <div role="region" aria-label="email us description" className="jss15 situationMsg mb-4">Our Customer Care Team
                            is working hard to answer messages as quickly as possible. We are experiencing a record number of
                            emails. Thank you for understanding during this extraordinary time. We will reply to your inquiry as
                            soon as we can.
                        </div>
                        <div role="region" aria-label="enter order number and email heading" className="requiredValidation">
                            Please enter your Order Number and Email Address
                        </div>
                    </div>

                    <div className="mt-2 pt-md-1">
                        <form className="form-container" onSubmit={(event) => this.handleSubmit(event)} disabled={!isReadyState}>
                            <Grid xs={12} sm={12} md={12} lg={12} item className={`${classes.inputWrapper} ${classes.inputLabel}`}>
                                <InputLabel htmlFor="orderNumber" className={classes.inputTitle}>
                                    {dataDictionary?.['Order Number'] || 'Order Number'}
                                </InputLabel>
                                <TextFieldWrapper
                                    isPlants
                                    customInput
                                    showErrorIcon={false}
                                    label="Order Number"
                                    name="orderNumber"
                                    inputType="AlphaNumericSpecial"
                                    validateRule="OrderNumber"
                                    required={formFieldState.orderNumber.required}
                                    flagError={formFieldState.orderNumber.flagError}
                                    errorMessage={formFieldState.orderNumber.errorMessage}
                                    variant="outlined"
                                    val={this.state.data.orderNumber}
                                    max={15}
                                    isInputFilled={handleFieldBlur}
                                    setTextInputState={handleFieldChange}
                                />
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12} item className={`${classes.inputWrapper} ${classes.inputLabel}`}>
                                <InputLabel htmlFor="email" className={classes.inputTitle}>
                                    {dataDictionary?.['Email Address'] || 'Email Address'}
                                </InputLabel>
                                <TextFieldWrapper
                                    isPlants
                                    customInput
                                    showErrorIcon={false}
                                    label="Email Address"
                                    name="email"
                                    inputType="email"
                                    required={formFieldState.email.required}
                                    flagError={formFieldState.email.flagError}
                                    errorMessage={formFieldState.email.errorMessage}
                                    variant="outlined"
                                    validateRule="Email"
                                    val={this.state.data.email}
                                    isInputFilled={handleFieldBlur}
                                    setTextInputState={handleFieldChange}
                                />
                            </Grid>
                            {error && (
                                <div className="alert">
                                    <Alert severity="error">
                                        {error}
                                    </Alert>
                                </div>
                            )}
                            <Button
                                variant="contained"
                                color="primary"
                                type="submit"
                            >
                                TRACK ORDER
                            </Button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

DesktopOrderByEmail.propTypes = {
    isReadyState: PropTypes.bool.isRequired,
    handleSubmitOrderByEmail: PropTypes.func.isRequired,
    featureFlags: PropTypes.shape({
        'is-order-page-using-ross-endpoint': PropTypes.bool,
    }).isRequired,
    handleOnBlur: PropTypes.func.isRequired,
    dataDictionary: object.isRequired,
    formFieldState: shape({
        email: shape({
            required: bool,
            flagError: bool,
            errorMessage: string,
        }).isRequired,
        orderNumber: shape({
            required: bool,
            flagError: bool,
            errorMessage: string,
        }).isRequired,
    }).isRequired,
    classes: object.isRequired,
    ssrDeviceType: string.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isReadyState: newState.isReadyState,
        toggleState: newState.toggleState,
        error: newState.error,
        orderStatus: getOrderStatus(state),
        orderConfirmationId: getOrderConfirmationId(state),
        dataDictionary: getDataDictionary(state),
        ssrDeviceType: getSSRDeviceType(state),
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleSubmitOrderByEmail: (data) => dispatch(EventDispatcher.handleSubmitOrderByEmail(data)),
});

const initState = {
    orderNumber: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    email: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(DesktopTrackOrderByEmailStyle),
)(withValidation(DesktopOrderByEmail, initState));
